export const FALLBACK_CURRENCIES = [
  { code: 'VUV', label: 'Vanuatu Vatu (VUV)' },
  { code: 'USD', label: 'US Dollar (USD)' },
  { code: 'AUD', label: 'Australian Dollar (AUD)' },
  { code: 'NZD', label: 'New Zealand Dollar (NZD)' },
  { code: 'GBP', label: 'British Pound (GBP)' },
  { code: 'EUR', label: 'Euro (EUR)' },
];

// All ISO 4217 currencies the browser knows about, with readable names —
// falls back to a short curated list on very old browsers.
export const CURRENCIES: { code: string; label: string }[] = (() => {
  if (typeof Intl.supportedValuesOf !== 'function') return FALLBACK_CURRENCIES;
  try {
    const names = new Intl.DisplayNames(['en'], { type: 'currency' });
    return Intl.supportedValuesOf('currency')
      .map((code) => ({ code, label: `${names.of(code)} (${code})` }))
      .sort((a, b) => a.label.localeCompare(b.label));
  } catch {
    return FALLBACK_CURRENCIES;
  }
})();
